export { WarningTemplateComponent } from '~ng-common-lib/ui/modals';
